import { DelayEvent } from '../types/ViewModel/DelayEvent';
import { DelayEventBM } from '../types/BusinessModel/DelayEventBM';

export class DelayEventFactory {
    public newDelayEvent(delayEvent: DelayEventBM): DelayEvent {
        return new DelayEvent(
            delayEvent.delayEventId,
            delayEvent.eventTypeId,
            delayEvent.delayEventTypeStartId,
            delayEvent.delayEventTypeStopId,
            delayEvent.delayStartEventTypeInputId,
            delayEvent.delayStopEventTypeInputId
        );
    }

    public createDelayEvent(delayEvent: DelayEvent | null): DelayEvent | null {
        if (delayEvent) {
            return new DelayEvent(
                delayEvent.delayEventId,
                delayEvent.eventTypeId,
                delayEvent.delayEventTypeStartId,
                delayEvent.delayEventTypeStopId,
                delayEvent.delayStartEventTypeInputId,
                delayEvent.delayStopEventTypeInputId
            );
        }
        return null;
    }
}
